import React, { useEffect, useState } from "react";
import "../page/ProductionDowntime.css";

// --- Config ---------------------------------------------------------
// Set to your real end time, or null to hide the ETA pill.
const ETA = new Date("2026-08-07T14:30:00Z");

// Point at a real status endpoint returning { message, percent }.
// Leave null to show a static message instead of polling.
const STATUS_ENDPOINT = null;
const STATUS_POLL_MS = 15000;

const NOTIFY_ENDPOINT = "/api/notify-me";

const DowntimePage = () => {
  const [status, setStatus] = useState({
    message: "Maintenance in progress",
    percent: 50,
  });
  const [email, setEmail] = useState("");
  const [notifyState, setNotifyState] = useState("idle"); // idle | sending | done | error

  useEffect(() => {
    if (!STATUS_ENDPOINT) return;

    let cancelled = false;

    const poll = async () => {
      try {
        const res = await fetch(STATUS_ENDPOINT, { cache: "no-store" });
        if (!res.ok) throw new Error("bad response");
        const data = await res.json();
        if (cancelled) return;
        setStatus({
          message: data.message || "Maintenance in progress",
          percent: Math.max(0, Math.min(100, Math.round(data.percent ?? 0))),
        });
        if (data.percent >= 100) window.location.reload();
      } catch {
        if (!cancelled) setStatus((s) => ({ ...s, message: "Checking status…" }));
      }
    };

    poll();
    const id = setInterval(poll, STATUS_POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const etaLabel =
    ETA && !Number.isNaN(ETA.getTime())
      ? ETA.toLocaleString(undefined, {
          hour: "numeric",
          minute: "2-digit",
          timeZoneName: "short",
        })
      : null;

  const handleNotifySubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) return;

    setNotifyState("sending");
    try {
      const res = await fetch(NOTIFY_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error("request failed");
      setNotifyState("done");
      setEmail("");
    } catch {
      setNotifyState("error");
    }
  };

  return (
    <div className="downtime-page">
      <div className="downtime-content">
        <div className="downtime-icon" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>

        <h1 className="downtime-heading">We'll be back soon</h1>
        <p className="downtime-description">
          Application is down for scheduled maintenance and expects to be back online in few hours.
        </p>

        {/* {etaLabel && (
          <div className="downtime-eta-pill">
            <span>Expected back by</span>
            <strong>{etaLabel}</strong>
          </div>
        )}

        <section className="downtime-status-card">
          <p className="downtime-status-label">Status</p>
          <div className="downtime-status-row">
            <span className="downtime-status-dot" />
            <span>{status.message}</span>
          </div>
          <div className="downtime-progress-track">
            <div
              className="downtime-progress-fill"
              style={{ width: `${status.percent}%` }}
            />
          </div>
          <p className="downtime-progress-note">{status.percent}% complete</p>
        </section>

        <form className="downtime-notify-form" onSubmit={handleNotifySubmit}>
          <label htmlFor="notify-email" className="sr-only">
            Email address
          </label>
          <input
            id="notify-email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={notifyState === "sending"}>
            Notify me
          </button>
        </form>
        <p className="downtime-notify-message" role="status" aria-live="polite">
          {notifyState === "sending" && "Sending…"}
          {notifyState === "done" && "We'll email you when we're back."}
          {notifyState === "error" && "Couldn't save that. Try again in a moment."}
        </p>

        <nav className="downtime-links">
          <a href="/status" target="_blank" rel="noopener noreferrer">
            Status updates
          </a>
          <a href="mailto:support@sleeknote.com">Support</a>
        </nav> */}
      </div>
    </div>
  );
};

export default DowntimePage;